<template>
  <section id="LinesOfActivity" class="section section-2 light-background">
    <div class="container">
      <h2>{{ $t("fieldsOfActivity") }}</h2>
      <div class="row justify-space-between">
        <div
          class="col-md-3 p-3 m-0"
          v-for="loaItem of loaItems"
          v-bind:key="loaItem._id"
        >
          <a :href="loaItem.link">
            <div class="image-container">
              <img
                v-if="loaItem.listImage"
                :src="
                  'https://cdn.tavakademi.com/uploads/5ef1b5f29a24df0df44f084c/static-pages/list-images/' +
                    loaItem.listImage
                "
                alt=""
                width="100%"
              />
              <img v-else src="@/assets/img/ph-loa.jpg" alt="" width="100%" />
              <p>{{ loaItem.title }}</p>
            </div>
          </a>
          <p class="mt-3" :inner-html.prop="loaItem.description"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContentService from "@/services/ContentService.js";
export default {
  data() {
    return {
      loaItems: [],
    };
  },
  created() {
    ContentService.getLinesOfActivity(this.$application, this.$t("languageCode"))
      .then((res) => (this.loaItems = res.data.data))
      .catch((error) => console.log("There was an error:" + error));
  },
};
</script>

<style></style>
